import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import CareGuideNoteForm from '../containers/CareGuideNoteFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideNoteAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideNoteAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) =>
        <div>
          <DocumentHead title={t('care_guide_note_route_add')} />
          <CareGuideNoteForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideNoteAddScreen;

Logger.log('silly', `CareGuideNoteAddScreen loaded.`);